export default __webpack_public_path__ + "static/media/bg-image.3d67fd8a.png";